<template>
  <nav>
    <h2>Charter</h2>
    <menu>
      <NavLink :to="{ name: 'charter-flights-overview' }" label="Flights overview" icon="flight" tooltip="Charter Flights overview" />
      <NavLink :to="{ name: 'charter-changes' }" label="Changes" icon="swap_horiz" tooltip="Charter Changes" />
      <NavLink :to="{ name: 'charter-daily-departures' }" label="Daily departures" icon="event" tooltip="Charter Daily departures" />
      <NavLink :to="{ name: 'charter-crew-briefing' }" label="Crew briefing" icon="assignment" tooltip="Charter Crew briefing" />
    </menu>

    <h2>Administration</h2>
    <menu>
      <NavLink :to="{ name: 'charter-audit-logs' }" label="Audit logs" icon="history" tooltip="Charter Audit logs" />
      <NavLink :to="{ name: 'charter-master-data' }" label="Master data" icon="storage" tooltip="Charter Master data" />
      <NavLink :to="{ name: 'charter-users' }" label="Users" icon="group" tooltip="Charter Users" />
      <NavLink :to="{ name: 'charter-financial-report' }" label="Financial report" icon="analytics" tooltip="Charter Financial report" />
    </menu>
  </nav>
</template>
<script setup lang="ts">
import NavLink from '@/components/structure/NavLink.vue';
</script>
